module.exports = __webpack_public_path__ + "assets/ic-discord.46c206b0.svg";